import { trackAnalyticsEvent } from '@eb/site-analytics';

import {
    GA_ORGANIZER_CATEGORY,
    GA_SHARE_ACTION,
    GA_SHARETYPE_MAP,
    GA_SHARE_ATTEMPT_ACTION,
    VIEW_EVENT_GA_ACTION,
    BOOKMARK_GA_ACTION,
    UNBOOKMARK_GA_ACTION,
} from './constants';

export const trackShareOptionClick = (shareType: string) =>
    trackAnalyticsEvent({
        category: GA_ORGANIZER_CATEGORY,
        action: GA_SHARE_ACTION,
        label: GA_SHARETYPE_MAP[shareType],
    });

export const trackShareClick = (id: string) =>
    trackAnalyticsEvent({
        category: GA_ORGANIZER_CATEGORY,
        action: GA_SHARE_ATTEMPT_ACTION,
        label: id,
    });

export const trackEventClick = (id: string) =>
    trackAnalyticsEvent({
        action: VIEW_EVENT_GA_ACTION,
        category: GA_ORGANIZER_CATEGORY,
        label: id,
    });

export const trackSaveEvent = (saved: boolean, id: string) =>
    trackAnalyticsEvent({
        category: GA_ORGANIZER_CATEGORY,
        action: saved ? BOOKMARK_GA_ACTION : UNBOOKMARK_GA_ACTION,
        label: id,
        dimensions: {
            eventId: id,
        },
    });
